import { useReducer, useState } from "react";
import {
  FormReducer,
  Action,
  FormDispatch,
  FormStateType,
} from "../Helpers/formTypes";
import { specializationInitialState } from "../Helpers/initialState/specializationInitialState";
import { serviceInitialState } from "../Helpers/initialState/serviceInitialState";
import { locationInitialState } from "../Helpers/initialState/locationInitialState";
import { appointmentInitialState } from "../Helpers/initialState/appointmentInitialState";
import { doctorInitialState } from "../Helpers/initialState/doctorInitialState";
import { bookingResponseInitialState } from "../Helpers/initialState/bookingResponseInitialState";
import { pricingSummaryInitialState } from "../Helpers/initialState/pricingSummaryInitialState";
import { serviceGroupInitialState } from "../Helpers/initialState/serviceGroupInitialState";
import { missingAppointmentsInitialState } from "../Helpers/initialState/missingAppointmentsInitialState";

export const initialFormState: FormStateType = {
  specialization: specializationInitialState,
  service: serviceInitialState,
  serviceSecondLevel: serviceInitialState,
  serviceGroup: serviceGroupInitialState,
  location: locationInitialState,
  doctor: doctorInitialState,
  selectedDay: "",
  selectedMonth: "",
  appointment: appointmentInitialState,
  missingAppointments: missingAppointmentsInitialState,
  bookingResponse: bookingResponseInitialState,
  bookingSessionId: "",
  wasDifferentTimeZoneModalShown: false,
  currentStep: 1,
  remoteContact: {
    label: "",
    appointmentOptions: [],
  },
  pricingSummary: pricingSummaryInitialState,
  relatedServiceSetups: [],
  showRelatedServicesMap: new Map<number, boolean>(),
};

const reducer = (state: FormStateType, action: Action) => {
  switch (action.type) {
    case FormReducer.update:
      return {
        ...state,
        [action.field]: action.payload,
      };
    case FormReducer.clear:
      return {
        ...state,
        [action.field]: {},
      };
  }
};

export const useFormData = (): {
  state: FormStateType;
  dispatch: FormDispatch;
} => {
  const [state, dispatch] = useReducer(reducer, initialFormState);

  return { state, dispatch };
};

const useUi = (): {
  currentStep: number;
  nextStep: () => void;
  previousStep: () => void;
  setStep: (step: number) => void;
} => {
  const [currentStep, setCurrentStep] = useState<number>(1);

  const nextStep = (): void => {
    setCurrentStep(currentStep + 1);
  };
  const previousStep = (): void => {
    setCurrentStep(currentStep - 1);
  };

  const setStep = (step: number): void => {
    setCurrentStep(step);
  };

  return { currentStep, nextStep, previousStep, setStep };
};

export const useFormUI = (): {
  state: FormStateType;
  dispatch: FormDispatch;
  currentStep: number;
  nextStep: () => void;
  previousStep: () => void;
  setStep: (step: number) => void;
} => {
  const { state, dispatch } = useFormData();

  const { currentStep, nextStep, previousStep, setStep } = useUi();

  return {
    state,
    dispatch,
    currentStep,
    nextStep,
    previousStep,
    setStep,
  };
};
